import type { CollectionWithPois } from "@poi-planner/shared";

/** Collections the current user may add POIs to or remove them from. */
export function canEditCollection(
  collection: Pick<CollectionWithPois, "isOwner" | "permission">,
): boolean {
  return collection.isOwner || collection.permission === "editor";
}
